import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { GetSettlementAccountCurrentAccountBasicTerminationResponseSettlementTypeV1 } from '../../../../api/generated/cz.partners.bank.termination.account.cab.boa';
import { clientAccountsPageValidateSearchSchema } from '../../products/ClientAccountsPage/route';
import { accountTerminationReason } from '../constants/accountTerminationReason';
import { accountTerminationRoute } from '../route';

import { accountTerminationAuthorizationType } from './accountTerminationSummaryForm';

const accountTerminationSummaryRouteSearchSchema =
	clientAccountsPageValidateSearchSchema.extend({
		reason: z.enum(accountTerminationReason),
		reasonNote: z.string().optional(),
		settlementAccountIbans: z.array(z.string()),
		settlementType: z.enum(
			GetSettlementAccountCurrentAccountBasicTerminationResponseSettlementTypeV1,
		),
		terminationDate: z.coerce.date(),
		authorizationType: z
			.enum(accountTerminationAuthorizationType)
			.optional()
			.catch(undefined),
		documentUuids: z.array(z.string()).optional().prefault([]),
	});

export type AccountTerminationSummaryRouteSearch = z.infer<
	typeof accountTerminationSummaryRouteSearchSchema
>;

export const accountTerminationSummaryRoute = createRoute({
	getParentRoute: () => accountTerminationRoute,
	path: '/3-summary',
	component: lazyRouteComponent(
		() => import('./AccountTerminationSummaryPage'),
		'AccountTerminationSummaryPage',
	),
	validateSearch: accountTerminationSummaryRouteSearchSchema,
});
